import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "l-main" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "home" }

import WidgetSidebar from "@/components/widget/WidgetSidebar.vue";
import WidgetHeader from "@/components/widget/WidgetHeader.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(WidgetSidebar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(WidgetHeader),
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})